import route from './src/router/index'

export * from './src/router/index'

export default route
